import React, { FC } from 'react';
import { RatingCard } from '../RatingCard/RatingCard';
import ratingCardClasses from '../RatingCard/RatingCard.module.scss';
import ratingLayoutClasses from '../ratingCardLayout.module.scss';
import { RatingQrCode } from '../RatingQrCode/RatingQrCode';
import classes from './RatingThankYou.module.scss';

type RatingThankYouProps = {
  rating: number;
  textColor: string;
  thankYouText: string;
  blurredBackground?: boolean;
  qrUrl?: string | null;
  qrLabelText?: string | null;
  showQr?: boolean;
};

export const RatingThankYou: FC<RatingThankYouProps> = ({
  rating,
  textColor,
  thankYouText,
  blurredBackground = false,
  qrUrl,
  qrLabelText,
  showQr
}) => (
  <div className={classes.overlay} role="dialog" aria-modal="true">
    <div className={ratingLayoutClasses.cardLayer}>
      <RatingCard
        textColor={textColor}
        blurredBackground={blurredBackground}
        className={ratingCardClasses.panelRating}
      >
        <div className={ratingLayoutClasses.ratingCardContent}>
          <div className={classes.message}>
            {thankYouText ? <p className={classes.title}>{thankYouText}</p> : null}
            <p className={classes.subtitle}>Ваша оценка {rating} отправлена!</p>
          </div>
          {showQr && qrUrl && (
            <RatingQrCode url={qrUrl} labelText={qrLabelText} />
          )}
        </div>
      </RatingCard>
    </div>
  </div>
);
